import styled from 'styled-components';

export const SectionRoot = styled.div`
  display: grid;
  grid-template-columns: repeat(4, auto);
  gap: 2rem;
  margin: 2rem auto;
  justify-content: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width1080}) {
    grid-template-columns: repeat(3, auto);
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    grid-template-columns: repeat(2, auto);
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    grid-template-columns: repeat(2, auto);
    margin: 2rem;
  }
`;

export const LogoContainer = styled.div`
  border-radius: 1rem;
  box-shadow:
    0 -2px 4px rgba(0, 0, 0, 0.05),
    0 2px 6px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  width: 240px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width768}) {
    width: 200px;
    height: 100px;
    padding: 0rem;
  }

  @media only screen and (max-width: ${({ theme }) =>
      theme.breakpoint.width480}) {
    width: 100%;
  }
`;

export const LogoImage = styled.img`
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
`;

export const MoreInformationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;

  color: ${({ theme }) => theme.color.mobilityGrey};
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize.size20};
  font-weight: ${({ theme }) => theme.fontWeight.weight700};

  padding: 3rem 0rem;
`;
